import { render, staticRenderFns } from "./PopularTags.vue?vue&type=template&id=d3325eba&"
import script from "./PopularTags.vue?vue&type=script&lang=js&"
export * from "./PopularTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports